import { UserContextModel } from './models/user-context.model';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserContextService {
  public userContext;

  constructor() {
    this.userContext = new UserContextModel();
  }

  setUserContext(userContext) {
    this.userContext.id = userContext.id;
    this.userContext.accountId = userContext.accountId;
    this.userContext.name = userContext.name;

    this.userContext.operatorContext.chatWelcomeMessageId = userContext.chatWelcomeMessageId;
    this.userContext.operatorContext.textChatWelcomeMessageId = userContext.textChatWelcomeMessageId;
    this.userContext.operatorContext.useAnswerNext = userContext.useAnswerNext;
    this.userContext.operatorContext.clientId = userContext.clientId;
  }
}
